export interface IDonorConnectEmailRequest {
    regId: number,
    centerId: number,
    replyToEmail: string,
    donorEmail: string,
    toEmail: string,
    subject: string,
    content: string,
    emailSent: boolean,
    emailSentDate: string
}